import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";

// ── Load Tabler Icons webfont once ────────────────────────────────────────────

function useTablerIcons() {
  useEffect(() => {
    if (document.getElementById("tabler-icons-cdn")) return;
    const link = document.createElement("link");
    link.id = "tabler-icons-cdn";
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css";
    document.head.appendChild(link);
  }, []);
}

// ── Internal StaffRow ─────────────────────────────────────────────────────────

function StaffRow({ p, teamMenuOpen, setTeamMenuOpen, onRemove, onChangeRole, onEditLocations, onEditName, isMe, isLead, onUpgradeToManager }) {
  const displayName = p.first_name && p.last_name ? `${p.first_name} ${p.last_name}` : p.name || "Unnamed";
  let badgeLetter, badgeStyle;
  if (p.is_admin === true) {
    badgeLetter = "AD"; badgeStyle = { background: "#6B21A8", border: "2.5px solid #D8B4FE", color: "#D8B4FE" };
  } else if (p.role === "manager") {
    badgeLetter = "M"; badgeStyle = { background: "#111", border: "2.5px solid #F55C00", color: "#F55C00" };
  } else if (p.staff_type === "lead" || p.staff_type === "head") {
    badgeLetter = "L"; badgeStyle = { background: "#F55C00", border: "2.5px solid #111", color: "white" };
  } else {
    badgeLetter = "A"; badgeStyle = { background: "white", border: "2.5px solid #111", color: "#111" };
  }
  return (
    <div style={{ borderBottom: "1px solid #EFEFEF" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 0" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: "50%", fontWeight: 700, fontSize: badgeLetter === "AD" ? 9 : 12, flexShrink: 0, ...badgeStyle }}>{badgeLetter}</span>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontWeight: 600, color: "#111", fontSize: 15 }}>{displayName}</span>
            {isMe && <span style={{ fontSize: 10, fontWeight: 700, color: "#F55C00", letterSpacing: 0.5, fontFamily: "'Oswald', sans-serif" }}>YOU</span>}
          </div>
        </div>
        {!isMe && (
          <div style={{ position: "relative" }}>
            {teamMenuOpen === p.id && <div onClick={() => setTeamMenuOpen(null)} style={{ position: "fixed", inset: 0, zIndex: 999 }} />}
            <button
              type="button"
              onClick={() => setTeamMenuOpen(teamMenuOpen === p.id ? null : p.id)}
              style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#F55C00", padding: "4px 8px", fontFamily: "inherit", lineHeight: 1 }}
            >···</button>
            {teamMenuOpen === p.id && (
              <div style={{ position: "absolute", right: 0, top: "100%", background: "white", borderRadius: 12, boxShadow: "0 4px 20px rgba(0,0,0,0.12)", zIndex: 1000, minWidth: 200, border: "0.5px solid #F0F0F0", overflow: "hidden" }}>
                {p.role !== "manager" && (
                  <>
                    {/* Edit Name */}
                    <button type="button" onClick={() => { setTeamMenuOpen(null); onEditName(p); }}
                      style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", borderBottom: "0.5px solid #F5F5F5", fontSize: 14, fontWeight: 500, color: "#111", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                      <i className="ti ti-pencil" style={{ fontSize: 16, color: "#AAAAAA", flexShrink: 0 }} />Edit Name
                    </button>
                    {/* Edit Locations */}
                    <button type="button" onClick={() => { setTeamMenuOpen(null); onEditLocations(p); }}
                      style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", borderBottom: "0.5px solid #F5F5F5", fontSize: 14, fontWeight: 500, color: "#111", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                      <i className="ti ti-map-pin" style={{ fontSize: 16, color: "#AAAAAA", flexShrink: 0 }} />Edit Locations
                    </button>
                    {/* Divider */}
                    <div style={{ height: "0.5px", background: "#EFEFEF" }} />
                    {/* Upgrade to Manager (leads only) */}
                    {isLead && (
                      <button type="button" onClick={() => { setTeamMenuOpen(null); onUpgradeToManager(p); }}
                        style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", borderBottom: "0.5px solid #F5F5F5", fontSize: 14, fontWeight: 500, color: "#22C55E", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                        <i className="ti ti-arrow-up" style={{ fontSize: 16, color: "#22C55E", flexShrink: 0 }} />Upgrade to Manager
                      </button>
                    )}
                    {/* Make Assistant (leads only) */}
                    {isLead && (
                      <button type="button" onClick={() => { setTeamMenuOpen(null); onChangeRole(p, "Assistant"); }}
                        style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", borderBottom: "0.5px solid #F5F5F5", fontSize: 14, fontWeight: 500, color: "#E53935", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                        <i className="ti ti-arrow-down" style={{ fontSize: 16, color: "#E53935", flexShrink: 0 }} />Make Assistant
                      </button>
                    )}
                    {/* Make Lead (assistants only) */}
                    {!isLead && (
                      <button type="button" onClick={() => { setTeamMenuOpen(null); onChangeRole(p, "Lead"); }}
                        style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", borderBottom: "0.5px solid #F5F5F5", fontSize: 14, fontWeight: 500, color: "#22C55E", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                        <i className="ti ti-arrow-up" style={{ fontSize: 16, color: "#22C55E", flexShrink: 0 }} />Make Lead
                      </button>
                    )}
                    {/* Divider */}
                    <div style={{ height: "0.5px", background: "#EFEFEF" }} />
                    {/* Remove */}
                    <button type="button" onClick={() => { setTeamMenuOpen(null); onRemove(p); }}
                      style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", fontSize: 14, fontWeight: 500, color: "#E53935", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                      <i className="ti ti-user-x" style={{ fontSize: 16, color: "#E53935", flexShrink: 0 }} />Remove
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Home screen menu row ──────────────────────────────────────────────────────

function MenuRow({ icon, label, subtitle, onClick, soon, isLast, dimmed }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: "flex", alignItems: "center", gap: 14, width: "100%",
        padding: "15px 24px", background: "none", border: "none",
        borderBottom: isLast ? "none" : "0.5px solid #F5F5F5",
        cursor: onClick ? "pointer" : "default", textAlign: "left",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      {/* Icon wrap */}
      <div style={{ width: 36, height: 36, borderRadius: 10, background: "#F5F5F5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <i className={`ti ${icon}`} style={{ fontSize: 17, color: dimmed ? "#BBBBBB" : "#F55C00" }} />
      </div>
      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: dimmed ? "#BBBBBB" : "#111", lineHeight: 1.3 }}>{label}</div>
      </div>
      {/* Right side */}
      {soon ? (
        <span style={{ fontSize: 10, fontWeight: 700, color: "#999", background: "#F0F0F0", borderRadius: 20, padding: "3px 8px", fontFamily: "'Oswald', sans-serif", letterSpacing: 0.5, flexShrink: 0 }}>SOON</span>
      ) : (
        <i className="ti ti-chevron-right" style={{ fontSize: 14, color: "#CCCCCC", flexShrink: 0 }} />
      )}
    </button>
  );
}

// ── AdminDrawer ───────────────────────────────────────────────────────────────

export default function AdminDrawer({
  user,
  allProfiles = [],
  pendingProfiles = [],
  allLocations = [],
  drawerVisible,
  onClose,
  onShiftAdded,
  onInvite,
  onEditLocations,
  onEditName,
  onChangeRole,
  onRemove,
  onResendInvite,
}) {
  useTablerIcons();

  const [activePanel, setActivePanel] = useState("home");
  const [teamLocFilter, setTeamLocFilter] = useState(() => allLocations.length > 0 ? allLocations[0].name : "All");
  const [teamMenuOpen, setTeamMenuOpen] = useState(null);
  const [upgradeConfirm, setUpgradeConfirm] = useState(null);
  const [demoteConfirm, setDemoteConfirm] = useState(null);
  const [cancelInviteConfirm, setCancelInviteConfirm] = useState(null);
  const [adminMenuOpen, setAdminMenuOpen] = useState(null);
  const [locForm, setLocForm] = useState({ adding: false, editingId: null, editName: "", addName: "", saving: false });
  const [deleteLocConfirm, setDeleteLocConfirm] = useState(null);

  const firstName = user?.first_name || (user?.name ? user.name.split(" ")[0] : "");
  const lastName = user?.last_name || (user?.name ? user.name.split(" ").slice(1).join(" ") : "");
  const userName = firstName && lastName ? `${firstName} ${lastName}` : user?.name || "";
  const initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase() || "?";

  // ── My Team helpers ───────────────────────────────────────────────────────
  const locationProfiles = allProfiles.filter(p => {
    if (p.removed === true || p.active === false) return false;
    if (p.locations && p.locations.length > 0) return p.locations.includes(teamLocFilter);
    return (p.location || allLocations[0]?.name || "") === teamLocFilter;
  });
  const managers = locationProfiles.filter(p => p.role === "manager" && p.is_admin !== true);
  const leads = locationProfiles.filter(p => (p.staff_type === "lead" || p.staff_type === "head") && p.role !== "manager");
  const assistants = locationProfiles.filter(p => p.role === "employee" && p.staff_type !== "lead" && p.staff_type !== "head");

  // ── Locations CRUD ────────────────────────────────────────────────────────
  const addLocation = async () => {
    const name = locForm.addName.trim();
    if (!name) return;
    setLocForm(f => ({ ...f, saving: true }));
    await supabase.from("locations").insert({ name, org_id: user?.org_id || null });
    setLocForm({ adding: false, editingId: null, editName: "", addName: "", saving: false });
    onShiftAdded();
  };

  const saveLocationEdit = async () => {
    const name = locForm.editName.trim();
    if (!name || !locForm.editingId) return;
    setLocForm(f => ({ ...f, saving: true }));
    await supabase.from("locations").update({ name }).eq("id", locForm.editingId);
    setLocForm({ adding: false, editingId: null, editName: "", addName: "", saving: false });
    onShiftAdded();
  };

  const deleteLocation = async (id) => {
    await supabase.from("locations").delete().eq("id", id);
    setDeleteLocConfirm(null);
    onShiftAdded();
  };

  const isAdmin = user?.is_admin === true;

  // Panel title map
  const panelTitles = { managers: "ADMINS", locations: "LOCATIONS", myteam: "MY TEAM" };

  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
          zIndex: 1000, opacity: drawerVisible ? 1 : 0,
          transition: "opacity 0.28s cubic-bezier(0.4,0,0.2,1)",
        }}
      />

      {/* Drawer panel */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          position: "fixed", top: 0, right: 0, height: "100%", width: window.innerWidth > 768 ? "33vw" : "72%", maxWidth: window.innerWidth > 768 ? 480 : 320, minWidth: window.innerWidth > 768 ? 360 : "unset",
          background: "white", zIndex: 1001, display: "flex", flexDirection: "column",
          transform: drawerVisible ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.28s cubic-bezier(0.4,0,0.2,1)",
          boxShadow: "-4px 0 24px rgba(0,0,0,0.12)",
        }}
      >
        {/* ── Panel header — varies by activePanel ── */}
        {activePanel === "home" ? (
          <div style={{ padding: "56px 24px 20px", borderBottom: "0.5px solid #EFEFEF", flexShrink: 0 }}>
            {/* Name */}
            <div style={{ fontSize: 16, fontWeight: 700, color: "#111", fontFamily: "'Oswald', sans-serif", lineHeight: 1.2 }}>{userName}</div>
            {/* ADMIN label */}
            <div style={{ fontSize: 12, color: "#F55C00", fontFamily: "'Oswald', sans-serif", marginTop: 4 }}>ADMIN</div>
          </div>
        ) : (
          <div style={{ padding: "56px 20px 16px", borderBottom: "0.5px solid #EFEFEF", flexShrink: 0, display: "flex", alignItems: "center", gap: 12 }}>
            <button
              type="button"
              onClick={() => setActivePanel("home")}
              style={{ background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex", alignItems: "center", color: "#F55C00", WebkitTapHighlightColor: "transparent", flexShrink: 0 }}
            >
              <i className="ti ti-chevron-left" style={{ fontSize: 24 }} />
            </button>
            <span style={{ fontSize: 17, fontWeight: 700, color: "#111", fontFamily: "'Oswald', sans-serif", letterSpacing: 0.5 }}>
              {panelTitles[activePanel] || ""}
            </span>
          </div>
        )}

        {/* ── Scrollable content ── */}
        <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>

          {/* ── HOME panel ──────────────────────────────────────────────── */}
          {activePanel === "home" && (
            <div style={{ paddingTop: 8, paddingBottom: 8 }}>
              {/* Group 1 */}
              <MenuRow icon="ti-id-badge-2" label="My Team"        onClick={() => setActivePanel("myteam")}    isLast={false} />
              <MenuRow icon="ti-map-pin"    label="Locations"      onClick={() => setActivePanel("locations")} isLast={false} />
              <MenuRow icon="ti-users"      label="Admins"         onClick={() => setActivePanel("managers")}  isLast={true} />

              {/* Divider */}
              <div style={{ height: "1.5px", background: "#E0E0E0", margin: "8px 0" }} />

              {/* Group 2 */}
              <MenuRow icon="ti-settings"     label="Settings"      onClick={null} isLast={false} soon dimmed />
              <MenuRow icon="ti-credit-card"  label="Billing"       onClick={null} isLast={false} soon dimmed />
              <MenuRow icon="ti-bell"         label="Notifications" onClick={null} isLast={false} soon dimmed />
              <MenuRow icon="ti-help-circle"  label="Help"          onClick={null} isLast={true} soon dimmed />
            </div>
          )}

          {/* ── MY TEAM panel ────────────────────────────────────────────── */}
          {activePanel === "myteam" && (
            <div style={{ padding: "20px 20px calc(40px + env(safe-area-inset-bottom, 34px))" }}>
              {/* Location filter + invite button */}
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
                <select
                  value={teamLocFilter}
                  onChange={e => setTeamLocFilter(e.target.value)}
                  style={{ flex: 1, padding: "10px 14px", background: "#f5f5f5", border: "none", borderRadius: 10, fontSize: 14, fontWeight: 600, color: "#111", cursor: "pointer", appearance: "none", WebkitAppearance: "none", backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23111' d='M6 8L1 3h10z'/%3E%3C/svg%3E\")", backgroundRepeat: "no-repeat", backgroundPosition: "right 14px center", fontFamily: "inherit" }}
                >
                  {allLocations.map(l => (
                    <option key={l.name} value={l.name}>{l.name}</option>
                  ))}
                </select>
                <button
                  type="button"
                  onClick={onInvite}
                  style={{ width: 36, height: 36, borderRadius: "50%", background: "#F55C00", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0, WebkitTapHighlightColor: "transparent" }}
                >
                  <span style={{ color: "#fff", fontSize: 20, lineHeight: 1, fontWeight: 400, pointerEvents: "none" }}>+</span>
                </button>
              </div>

              {/* MANAGERS */}
              <div style={{ fontSize: 11, fontWeight: 700, color: "#111", letterSpacing: 1, marginBottom: 8, fontFamily: "'Oswald', sans-serif" }}>MANAGERS</div>
              {managers.length === 0 && <div style={{ fontSize: 13, color: "#aaa", paddingBottom: 8 }}>No managers at this location.</div>}
              {managers.map(p => (
                <div key={p.id} style={{ borderBottom: "1px solid #EFEFEF" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 0" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: "50%", fontWeight: 700, fontSize: 12, flexShrink: 0, background: "#111", border: "2.5px solid #F55C00", color: "#F55C00" }}>M</span>
                      <span style={{ fontWeight: 600, color: "#111", fontSize: 15 }}>{p.first_name && p.last_name ? `${p.first_name} ${p.last_name}` : p.name || "Unnamed"}</span>
                    </div>
                    <div style={{ position: "relative" }}>
                      {teamMenuOpen === p.id && <div onClick={() => setTeamMenuOpen(null)} style={{ position: "fixed", inset: 0, zIndex: 999 }} />}
                      <button
                        type="button"
                        onClick={() => setTeamMenuOpen(teamMenuOpen === p.id ? null : p.id)}
                        style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#F55C00", padding: "4px 8px", fontFamily: "inherit", lineHeight: 1 }}
                      >···</button>
                      {teamMenuOpen === p.id && (
                        <div style={{ position: "absolute", right: 0, top: "100%", background: "white", borderRadius: 12, boxShadow: "0 4px 20px rgba(0,0,0,0.12)", zIndex: 1000, minWidth: 200, border: "0.5px solid #F0F0F0", overflow: "hidden" }}>
                          <button type="button" onClick={() => { setTeamMenuOpen(null); onEditName(p); }}
                            style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", borderBottom: "0.5px solid #F5F5F5", fontSize: 14, fontWeight: 500, color: "#111", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                            <i className="ti ti-pencil" style={{ fontSize: 16, color: "#AAAAAA", flexShrink: 0 }} />Edit Name
                          </button>
                          <button type="button" onClick={() => { setTeamMenuOpen(null); onEditLocations(p); }}
                            style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", borderBottom: "0.5px solid #F5F5F5", fontSize: 14, fontWeight: 500, color: "#111", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                            <i className="ti ti-map-pin" style={{ fontSize: 16, color: "#AAAAAA", flexShrink: 0 }} />Edit Locations
                          </button>
                          <div style={{ height: "0.5px", background: "#EFEFEF" }} />
                          <button type="button" onClick={() => { setTeamMenuOpen(null); setDemoteConfirm(p); }}
                            style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", borderBottom: "0.5px solid #F5F5F5", fontSize: 14, fontWeight: 500, color: "#E53935", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                            <i className="ti ti-arrow-down" style={{ fontSize: 16, color: "#E53935", flexShrink: 0 }} />Demote to Lead
                          </button>
                          <div style={{ height: "0.5px", background: "#EFEFEF" }} />
                          <button type="button" onClick={() => { setTeamMenuOpen(null); onRemove(p); }}
                            style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", padding: "13px 16px", background: "none", border: "none", fontSize: 14, fontWeight: 500, color: "#E53935", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                            <i className="ti ti-user-x" style={{ fontSize: 16, color: "#E53935", flexShrink: 0 }} />Remove
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}

              {/* LEADS */}
              <div style={{ fontSize: 11, fontWeight: 700, color: "#111", letterSpacing: 1, margin: "20px 0 8px", fontFamily: "'Oswald', sans-serif" }}>LEADS</div>
              {leads.length === 0 && <div style={{ fontSize: 13, color: "#aaa", paddingBottom: 8 }}>No leads at this location.</div>}
              {leads.map(p => (
                <StaffRow key={p.id} p={p} teamMenuOpen={teamMenuOpen} setTeamMenuOpen={setTeamMenuOpen} onRemove={onRemove} onChangeRole={onChangeRole} onEditLocations={onEditLocations} onEditName={onEditName} isMe={p.id === user?.id} isLead onUpgradeToManager={setUpgradeConfirm} />
              ))}

              {/* ASSISTANTS */}
              <div style={{ fontSize: 11, fontWeight: 700, color: "#111", letterSpacing: 1, margin: "20px 0 8px", fontFamily: "'Oswald', sans-serif" }}>ASSISTANTS</div>
              {assistants.length === 0 && <div style={{ fontSize: 13, color: "#aaa", paddingBottom: 8 }}>No assistants at this location.</div>}
              {assistants.map(p => (
                <StaffRow key={p.id} p={p} teamMenuOpen={teamMenuOpen} setTeamMenuOpen={setTeamMenuOpen} onRemove={onRemove} onChangeRole={onChangeRole} onEditLocations={onEditLocations} onEditName={onEditName} isMe={p.id === user?.id} />
              ))}

              {/* PENDING */}
              <div style={{ fontSize: 11, fontWeight: 700, color: "#111", letterSpacing: 1, margin: "20px 0 8px", fontFamily: "'Oswald', sans-serif" }}>PENDING</div>
              {pendingProfiles.length === 0 ? (
                <div style={{ fontSize: 13, color: "#aaa", paddingBottom: 8 }}>No pending invites.</div>
              ) : pendingProfiles.map(p => {
                const displayName = p.first_name && p.last_name ? `${p.first_name} ${p.last_name}` : p.name || "Unnamed";
                return (
                  <div key={p.id} style={{ borderBottom: "1px solid #EFEFEF" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 0" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: "50%", fontWeight: 700, fontSize: 12, flexShrink: 0, opacity: 0.5, background: p.staff_type === "lead" ? "#F55C00" : "white", border: "2.5px solid #111", color: p.staff_type === "lead" ? "white" : "#111" }}>
                          {p.staff_type === "lead" ? "L" : "A"}
                        </span>
                        <div>
                          <div style={{ fontSize: 15, fontWeight: 600, color: "#111" }}>{displayName}</div>
                          <div style={{ fontSize: 12, color: "#aaa", marginTop: 2 }}>{p.email}</div>
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                        <button type="button" onClick={() => onResendInvite(p)} style={{ background: "#F55C00", border: "none", borderRadius: 20, padding: "6px 14px", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Resend</button>
                        <button type="button" onClick={() => setCancelInviteConfirm(p)} style={{ background: "white", border: "1px solid #E0E0E0", borderRadius: 20, padding: "6px 14px", color: "#E53935", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Cancel</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* ── MANAGERS panel ───────────────────────────────────────────── */}
          {activePanel === "managers" && isAdmin && (
            <div style={{ padding: "20px 20px calc(40px + env(safe-area-inset-bottom, 34px))" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#111", letterSpacing: 1, fontFamily: "'Oswald', sans-serif" }}>ALL ADMINS</div>
                <button type="button" onClick={() => onInvite("admin")} style={{ background: "#F55C00", color: "#fff", border: "none", borderRadius: 20, padding: "6px 16px", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "'Oswald', sans-serif", letterSpacing: 0.5 }}>+ INVITE ADMIN</button>
              </div>
              {allProfiles
                .filter(p => p.is_admin === true && p.active !== false && !p.removed)
                .map(p => {
                  const displayName = p.first_name && p.last_name ? `${p.first_name} ${p.last_name}` : p.name || "Unnamed";
                  return (
                    <div key={p.id} style={{ borderBottom: "1px solid #EFEFEF", padding: "14px 0" }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                        <div style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                          <div style={{ fontWeight: 600, color: "#111", fontSize: 15, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{displayName}</div>
                        </div>
                        <div style={{ position: "relative", flexShrink: 0 }}>
                          {adminMenuOpen === p.id && <div onClick={() => setAdminMenuOpen(null)} style={{ position: "fixed", inset: 0, zIndex: 999 }} />}
                          <button type="button" onClick={() => setAdminMenuOpen(adminMenuOpen === p.id ? null : p.id)} style={{ background: "none", border: "none", cursor: "pointer", padding: "4px 6px", color: "#F55C00", fontSize: 18, lineHeight: 1, display: "flex", alignItems: "center" }}>
                            <i className="ti ti-dots" />
                          </button>
                          {adminMenuOpen === p.id && (
                            <div style={{ position: "absolute", right: 0, top: "100%", background: "white", border: "1px solid #EFEFEF", borderRadius: 10, boxShadow: "0 4px 16px rgba(0,0,0,0.1)", zIndex: 1000, minWidth: 150, overflow: "hidden" }}>
                              <button type="button" onClick={() => { setAdminMenuOpen(null); onEditName(p); }} style={{ display: "block", width: "100%", textAlign: "left", padding: "12px 16px", fontSize: 14, fontWeight: 500, color: "#111", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit" }}>Edit Name</button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              {allProfiles.filter(p => p.is_admin === true && p.active !== false && !p.removed).length === 0 && (
                <div style={{ fontSize: 13, color: "#aaa", paddingTop: 4 }}>No admins yet.</div>
              )}
            </div>
          )}

          {/* ── LOCATIONS panel ──────────────────────────────────────────── */}
          {activePanel === "locations" && isAdmin && (
            <div style={{ padding: "20px 20px calc(40px + env(safe-area-inset-bottom, 34px))" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#111", letterSpacing: 1, fontFamily: "'Oswald', sans-serif" }}>LOCATIONS</div>
                {!locForm.adding && (
                  <button type="button" onClick={() => setLocForm(f => ({ ...f, adding: true, addName: "" }))} style={{ background: "#F55C00", color: "#fff", border: "none", borderRadius: 20, padding: "6px 16px", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "'Oswald', sans-serif", letterSpacing: 0.5 }}>+ ADD</button>
                )}
              </div>

              {/* Add form */}
              {locForm.adding && (
                <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
                  <input
                    autoFocus
                    type="text"
                    placeholder="Location name"
                    value={locForm.addName}
                    onChange={e => setLocForm(f => ({ ...f, addName: e.target.value }))}
                    onKeyDown={e => { if (e.key === "Enter") addLocation(); if (e.key === "Escape") setLocForm(f => ({ ...f, adding: false, addName: "" })); }}
                    style={{ flex: 1, border: "1.5px solid #F55C00", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
                  />
                  <button type="button" onClick={addLocation} disabled={locForm.saving} style={{ background: "#F55C00", color: "#fff", border: "none", borderRadius: 8, padding: "9px 16px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'Oswald', sans-serif", opacity: locForm.saving ? 0.6 : 1 }}>SAVE</button>
                  <button type="button" onClick={() => setLocForm(f => ({ ...f, adding: false, addName: "" }))} style={{ background: "none", color: "#111", border: "1px solid #EFEFEF", borderRadius: 8, padding: "9px 12px", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>✕</button>
                </div>
              )}

              {/* Location list */}
              {allLocations.map(loc => (
                <div key={loc.id} style={{ borderBottom: "1px solid #EFEFEF", padding: "14px 0" }}>
                  {locForm.editingId === loc.id ? (
                    <div style={{ display: "flex", gap: 8 }}>
                      <input
                        autoFocus
                        type="text"
                        value={locForm.editName}
                        onChange={e => setLocForm(f => ({ ...f, editName: e.target.value }))}
                        onKeyDown={e => { if (e.key === "Enter") saveLocationEdit(); if (e.key === "Escape") setLocForm(f => ({ ...f, editingId: null, editName: "" })); }}
                        style={{ flex: 1, border: "1.5px solid #F55C00", borderRadius: 8, padding: "8px 12px", fontSize: 14, fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
                      />
                      <button type="button" onClick={saveLocationEdit} disabled={locForm.saving} style={{ background: "#F55C00", color: "#fff", border: "none", borderRadius: 8, padding: "8px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'Oswald', sans-serif", opacity: locForm.saving ? 0.6 : 1 }}>SAVE</button>
                      <button type="button" onClick={() => setLocForm(f => ({ ...f, editingId: null, editName: "" }))} style={{ background: "none", color: "#111", border: "1px solid #EFEFEF", borderRadius: 8, padding: "8px 12px", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>✕</button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <span style={{ fontWeight: 600, color: "#111", fontSize: 15 }}>{loc.name}</span>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button type="button" onClick={() => setLocForm(f => ({ ...f, editingId: loc.id, editName: loc.name, adding: false }))} style={{ background: "none", border: "1px solid #EFEFEF", borderRadius: 8, padding: "5px 12px", fontSize: 12, fontWeight: 700, color: "#111", cursor: "pointer", fontFamily: "'Oswald', sans-serif" }}>EDIT</button>
                        <button type="button" onClick={() => setDeleteLocConfirm(loc)} style={{ background: "none", border: "1px solid #EFEFEF", borderRadius: 8, padding: "5px 12px", fontSize: 12, fontWeight: 700, color: "#E53935", cursor: "pointer", fontFamily: "'Oswald', sans-serif" }}>DELETE</button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
              {allLocations.length === 0 && !locForm.adding && (
                <div style={{ fontSize: 13, color: "#aaa", paddingTop: 4 }}>No locations yet.</div>
              )}

              {/* Delete confirm */}
              {deleteLocConfirm && (
                <div
                  style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 24px" }}
                  onClick={() => setDeleteLocConfirm(null)}
                >
                  <div style={{ background: "white", borderRadius: 16, padding: "28px 24px", width: "100%", maxWidth: 320 }} onClick={e => e.stopPropagation()}>
                    <p style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 8, lineHeight: 1.4, fontFamily: "'Oswald', sans-serif" }}>DELETE {deleteLocConfirm.name.toUpperCase()}?</p>
                    <p style={{ fontSize: 13, color: "#111", marginBottom: 24, lineHeight: 1.4 }}>This location will be removed from the system. Existing shifts and profiles will not be affected.</p>
                    <div style={{ display: "flex", gap: 10 }}>
                      <button onClick={() => setDeleteLocConfirm(null)} style={{ flex: 1, background: "white", color: "#111", fontSize: 13, fontWeight: 700, borderRadius: 20, padding: "10px", border: "1.5px solid #111", cursor: "pointer", fontFamily: "inherit" }}>CANCEL</button>
                      <button onClick={() => deleteLocation(deleteLocConfirm.id)} style={{ flex: 1, background: "#E53935", color: "white", fontSize: 13, fontWeight: 700, borderRadius: 20, padding: "10px", border: "none", cursor: "pointer", fontFamily: "inherit" }}>DELETE</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* ── Footer ── */}
        <div style={{ borderTop: "0.5px solid #EFEFEF", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 24px" }}>
          <button
            type="button"
            onClick={async () => { onClose(); await supabase.auth.signOut(); }}
            style={{ background: "none", border: "none", padding: 0, fontSize: 13, fontWeight: 700, color: "#E53935", cursor: "pointer", fontFamily: "inherit" }}
          >Log out</button>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#DDDDDD", fontFamily: "'Oswald', sans-serif", letterSpacing: 1 }}>TMRW</span>
        </div>
      </div>

      {/* ── Demote to Lead confirm modal ── */}
      {demoteConfirm && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 2100, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 24px" }}
          onMouseDown={(e) => { if (e.target === e.currentTarget) setDemoteConfirm(null); }}
        >
          <div style={{ background: "white", borderRadius: 16, padding: "28px 24px", maxWidth: 340, width: "100%" }}>
            <p style={{ fontSize: 16, fontWeight: 700, color: "#111", marginBottom: 12, lineHeight: 1.3, fontFamily: "'Oswald', sans-serif" }}>
              DEMOTE {((demoteConfirm.first_name && demoteConfirm.last_name) ? `${demoteConfirm.first_name} ${demoteConfirm.last_name}` : demoteConfirm.name || "").toUpperCase()} TO LEAD?
            </p>
            <p style={{ fontSize: 13, color: "#111", marginBottom: 24, lineHeight: 1.5 }}>They will lose manager access and return to a Lead role immediately.</p>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                type="button"
                onClick={() => setDemoteConfirm(null)}
                style={{ flex: 1, background: "white", color: "#111", fontSize: 13, fontWeight: 700, borderRadius: 20, padding: "10px", border: "1.5px solid #111", cursor: "pointer", fontFamily: "inherit" }}
              >CANCEL</button>
              <button
                type="button"
                onClick={() => { onChangeRole(demoteConfirm, "Lead"); setDemoteConfirm(null); }}
                style={{ flex: 1, background: "#E53935", color: "white", fontSize: 13, fontWeight: 700, borderRadius: 20, padding: "10px", border: "none", cursor: "pointer", fontFamily: "inherit" }}
              >DEMOTE</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Cancel invite confirm modal ── */}
      {cancelInviteConfirm && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 2100, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 24px" }}
          onMouseDown={(e) => { if (e.target === e.currentTarget) setCancelInviteConfirm(null); }}
        >
          <div style={{ background: "white", borderRadius: 16, padding: "28px 24px", maxWidth: 340, width: "100%" }}>
            <p style={{ fontSize: 16, fontWeight: 700, color: "#111", marginBottom: 12, lineHeight: 1.3, fontFamily: "'Oswald', sans-serif" }}>
              CANCEL INVITE FOR {((cancelInviteConfirm.first_name && cancelInviteConfirm.last_name) ? `${cancelInviteConfirm.first_name} ${cancelInviteConfirm.last_name}` : cancelInviteConfirm.name || "").toUpperCase()}?
            </p>
            <p style={{ fontSize: 13, color: "#111", marginBottom: 24, lineHeight: 1.5 }}>This will cancel their pending invite. You can re-invite them at any time.</p>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                type="button"
                onClick={() => setCancelInviteConfirm(null)}
                style={{ flex: 1, background: "white", color: "#111", fontSize: 13, fontWeight: 700, borderRadius: 20, padding: "10px", border: "1.5px solid #111", cursor: "pointer", fontFamily: "inherit" }}
              >KEEP</button>
              <button
                type="button"
                onClick={async () => {
                  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
                  const { data: { session } } = await supabase.auth.getSession();
                  console.log("[cancel-invite] payload:", { profile_id: cancelInviteConfirm.id, email: cancelInviteConfirm.email });
                  await fetch(`${supabaseUrl}/functions/v1/cancel-invite`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token}` },
                    body: JSON.stringify({ profile_id: cancelInviteConfirm.id, email: cancelInviteConfirm.email }),
                  });
                  setCancelInviteConfirm(null);
                }}
                style={{ flex: 1, background: "#E53935", color: "white", fontSize: 13, fontWeight: 700, borderRadius: 20, padding: "10px", border: "none", cursor: "pointer", fontFamily: "inherit" }}
              >CANCEL INVITE</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Upgrade to Manager confirm modal ── */}
      {upgradeConfirm && (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 2100, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 24px" }}
          onMouseDown={(e) => { if (e.target === e.currentTarget) setUpgradeConfirm(null); }}
        >
          <div style={{ background: "white", borderRadius: 16, padding: "28px 24px", maxWidth: 340, width: "100%" }}>
            <p style={{ fontSize: 16, fontWeight: 700, color: "#111", marginBottom: 12, lineHeight: 1.3, fontFamily: "'Oswald', sans-serif" }}>
              UPGRADE {((upgradeConfirm.first_name && upgradeConfirm.last_name) ? `${upgradeConfirm.first_name} ${upgradeConfirm.last_name}` : upgradeConfirm.name || "").toUpperCase()} TO MANAGER?
            </p>
            <p style={{ fontSize: 13, color: "#111", marginBottom: 24, lineHeight: 1.5 }}>They will have full scheduling control over all assigned locations.</p>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                type="button"
                onClick={() => setUpgradeConfirm(null)}
                style={{ flex: 1, background: "white", color: "#111", fontSize: 13, fontWeight: 700, borderRadius: 20, padding: "10px", border: "1.5px solid #111", cursor: "pointer", fontFamily: "inherit" }}
              >CANCEL</button>
              <button
                type="button"
                onClick={() => { onChangeRole(upgradeConfirm, "Manager"); setUpgradeConfirm(null); }}
                style={{ flex: 1, background: "#22C55E", color: "white", fontSize: 13, fontWeight: 700, borderRadius: 20, padding: "10px", border: "none", cursor: "pointer", fontFamily: "inherit" }}
              >UPGRADE</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
